import primaryLogo from "assets/img/primaryLogo.png";
import {postLoginViaBackDoor} from "modules/actions/user";
import React from "react";
import {useDispatch} from "react-redux";
import styled from "@emotion/styled";

const BackDoorPageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;
	padding: 20px;

	img {
		margin-bottom: 30px;
	}
`;

const Input = styled.input`
	height: 40px;
	border-radius: 20px;
	padding: 0 10px;
	margin-bottom: 20px;
	min-width: 300px;

	&:focus {
		box-shadow: 0 0 3px 3px rgba(0, 200, 0, 1);
	}
`;

const Form = styled.form`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	button {
		width: 100%;
		height: 40px;
		border-radius: 20px;
		background: rgba(0, 200, 0, 1);
		box-shadow: none;
		border: none;
	}
`;

const Label = styled.label`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: 40px;
	width: 100%;
	margin-bottom: 20px;
	input {
		width: 20px;
		height: 20px;
		margin-right: 20px;
	}
`;
const BackDoorPage: React.FC = () => {
	const dispatch = useDispatch();

	const onSubmit = (e: React.FocusEvent<HTMLFormElement>) => {
		const formData = new FormData(e.target);
		dispatch(postLoginViaBackDoor(formData));
		e.preventDefault();
	};

	return (
		<BackDoorPageWrapper>
			<img src={primaryLogo} alt="The main logo of MLB" />

			<Form onSubmit={onSubmit}>
				<Input name="email" type="email" placeholder="Please enter you email" />
				<Input name="password" type="password" placeholder="Please enter you password" />
				<Label>
					<input name="isOptIn" type="checkbox" /> is opt in
				</Label>
				<button type="submit">Go</button>
			</Form>
		</BackDoorPageWrapper>
	);
};

export default BackDoorPage;
